export default __webpack_public_path__ + "static/media/testimonial-1.f2dfe2f3.jpg";